import type { ContractorGetCampaignModel, ManagerGetCampaignModel } from 'entities/campaign';
import { useState } from 'react';

export const useTestLeads = () => {
  const [openedTestLeads, setOpenedTestLeads] = useState<Record<string, boolean>>({});

  const openTestLead = (id: string) => {
    setOpenedTestLeads((prev) => ({
      ...prev,
      [id]: true,
    }));
  };

  const closeTestLead = (id: string) => {
    setOpenedTestLeads((prev) => {
      const newState = { ...prev };

      delete newState[id];

      return newState;
    });
  };

  const clearAllLeads = () => setOpenedTestLeads({});

  return {
    openTestLead,
    openedTestLeads,
    closeTestLead,
    clearAllLeads,
  };
};

interface UseShowCallCenterBannerParams {
  campaign: ManagerGetCampaignModel | ContractorGetCampaignModel;
}

export const useShowCallCenterBanner = ({ campaign }: UseShowCallCenterBannerParams) => {
  const isShowCallCenterBanner =
    campaign.type === 'appt' && !campaign.callCenterHasCustomSchedule && campaign.isCustomScheduleFeatureEnabled;
  const isShowCallCenterTime = campaign.callCenterHasCustomSchedule && campaign.isCustomScheduleFeatureEnabled;

  return {
    isShowCallCenterBanner,
    isShowCallCenterTime,
  };
};
